module.exports = __webpack_public_path__ + "img/1-start_v8e_front_loading.b7bf164d.jpg";